"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.SegmentModel = exports.SegmentRuleModel = exports.SegmentConditionModel = exports.getMatchingFunctions = exports.semverMatchingFunction = exports.matchingFunctions = exports.any = exports.all = void 0;
var semver_1 = __importDefault(require("semver"));
var utils_1 = require("../utils");
var constants_1 = require("./constants");
var util_1 = require("./util");
var all = function (iterable) { return iterable.filter(function (e) { return !!e; }).length === iterable.length; };
exports.all = all;
var any = function (iterable) { return iterable.filter(function (e) { return !!e; }).length > 0; };
exports.any = any;
exports.matchingFunctions = (_a = {},
    _a[constants_1.CONDITION_OPERATORS.EQUAL] = function (thisValue, otherValue) { return thisValue == otherValue; },
    _a[constants_1.CONDITION_OPERATORS.GREATER_THAN] = function (thisValue, otherValue) { return otherValue > thisValue; },
    _a[constants_1.CONDITION_OPERATORS.GREATER_THAN_INCLUSIVE] = function (thisValue, otherValue) {
        return otherValue >= thisValue;
    },
    _a[constants_1.CONDITION_OPERATORS.LESS_THAN] = function (thisValue, otherValue) { return thisValue > otherValue; },
    _a[constants_1.CONDITION_OPERATORS.LESS_THAN_INCLUSIVE] = function (thisValue, otherValue) {
        return thisValue >= otherValue;
    },
    _a[constants_1.CONDITION_OPERATORS.NOT_EQUAL] = function (thisValue, otherValue) { return thisValue != otherValue; },
    _a[constants_1.CONDITION_OPERATORS.CONTAINS] = function (thisValue, otherValue) {
        return !!otherValue && otherValue.includes(thisValue);
    },
    _a);
exports.semverMatchingFunction = __assign(__assign({}, exports.matchingFunctions), (_b = {}, _b[constants_1.CONDITION_OPERATORS.EQUAL] = function (thisValue, otherValue) { return semver_1.default.eq(thisValue, otherValue); }, _b[constants_1.CONDITION_OPERATORS.GREATER_THAN] = function (thisValue, otherValue) { return semver_1.default.gt(otherValue, thisValue); }, _b[constants_1.CONDITION_OPERATORS.GREATER_THAN_INCLUSIVE] = function (thisValue, otherValue) {
    return semver_1.default.gte(otherValue, thisValue);
}, _b[constants_1.CONDITION_OPERATORS.LESS_THAN] = function (thisValue, otherValue) { return semver_1.default.gt(thisValue, otherValue); }, _b[constants_1.CONDITION_OPERATORS.LESS_THAN_INCLUSIVE] = function (thisValue, otherValue) {
    return semver_1.default.gte(thisValue, otherValue);
}, _b));
var getMatchingFunctions = function (semver) { return (semver ? exports.semverMatchingFunction : exports.matchingFunctions); };
exports.getMatchingFunctions = getMatchingFunctions;
var SegmentConditionModel = /** @class */ (function () {
    function SegmentConditionModel(operator, value, property) {
        var _a;
        this.EXCEPTION_OPERATOR_METHODS = (_a = {},
            _a[constants_1.NOT_CONTAINS] = 'evaluateNotContains',
            _a[constants_1.REGEX] = 'evaluateRegex',
            _a[constants_1.MODULO] = 'evaluateModulo',
            _a[constants_1.IN] = 'evaluateIn',
            _a);
        this.operator = operator;
        this.value = value;
        this.property_ = property;
    }
    SegmentConditionModel.prototype.matchesTraitValue = function (traitValue) {
        var _this = this;
        var evaluators = {
            evaluateNotContains: function (traitValue) {
                var _a;
                return typeof traitValue == "string" &&
                    !!_this.value &&
                    !traitValue.includes((_a = _this.value) === null || _a === void 0 ? void 0 : _a.toString());
            },
            evaluateRegex: function (traitValue) {
                return !!_this.value && !!(traitValue === null || traitValue === void 0 ? void 0 : traitValue.toString().match(new RegExp(_this.value)));
            },
            evaluateModulo: function (traitValue) {
                if (isNaN(parseFloat(traitValue)) || !_this.value) {
                    return false;
                }
                var parts = (_this.value).split("|");
                var _a = __read([parseFloat(parts[0]), parseFloat(parts[1])], 2), divisor = _a[0], reminder = _a[1];
                return traitValue % divisor === reminder;
            },
            evaluateIn: function (traitValue) {
                var _a;
                return (_a = _this.value) === null || _a === void 0 ? void 0 : _a.split(',').includes(traitValue.toString());
            },
        };
        // TODO: move this logic to the evaluator module
        if (this.EXCEPTION_OPERATOR_METHODS[this.operator]) {
            var evaluatorFunction = evaluators[this.EXCEPTION_OPERATOR_METHODS[this.operator]];
            return evaluatorFunction(traitValue);
        }
        var defaultFunction = function (x, y) { return false; };
        var matchingFunctionSet = (0, exports.getMatchingFunctions)((0, util_1.isSemver)(this.value));
        var matchingFunction = matchingFunctionSet[this.operator] || defaultFunction;
        var traitType = (0, util_1.isSemver)(this.value) ? 'semver' : typeof traitValue;
        var castToTypeOfTraitValue = (0, utils_1.getCastingFunction)(traitType);
        return matchingFunction(castToTypeOfTraitValue(this.value), traitValue);
    };
    return SegmentConditionModel;
}());
exports.SegmentConditionModel = SegmentConditionModel;
var SegmentRuleModel = /** @class */ (function () {
    function SegmentRuleModel(type) {
        this.rules = [];
        this.conditions = [];
        this.type = type;
    }
    SegmentRuleModel.none = function (iterable) {
        return iterable.filter(function (e) { return !!e; }).length === 0;
    };
    SegmentRuleModel.prototype.matchingFunction = function () {
        var _a;
        return (_a = {},
            _a[constants_1.ANY_RULE] = exports.any,
            _a[constants_1.ALL_RULE] = exports.all,
            _a[constants_1.NONE_RULE] = SegmentRuleModel.none,
            _a)[this.type];
    };
    return SegmentRuleModel;
}());
exports.SegmentRuleModel = SegmentRuleModel;
var SegmentModel = /** @class */ (function () {
    function SegmentModel(id, name) {
        this.rules = [];
        this.featureStates = [];
        this.id = id;
        this.name = name;
    }
    return SegmentModel;
}());
exports.SegmentModel = SegmentModel;
